/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const StravaIconConfig = {
  name: 'StravaIcon',
  height: 512,
  width: 384,
  svgPath: 'M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(StravaIconConfig);
//# sourceMappingURL=strava-icon.js.map